<item-nav>
    <a id="{ props.id }" href="{ props.link }" class="{ state.active ? 'bg-cyan-700 text-white' : 'text-cyan-200 hover:text-white hover:bg-cyan-700' } group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold">
        <svg if="{ props.id === KEYS.COMMESSE }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
        <svg if="{ props.id === KEYS.TASK }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z" />
        </svg>

        { props.title }
    </a>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { EVENTS, KEYS } from '/src/utils/constants'

        export default {
            KEYS: KEYS,
            onBeforeMount(props, state) {
                this.state = {
                    active: false,
                    user: StoreService.getUser()
                }

                eventBus.on(EVENTS.UI.UPDATE_NAV, this.handleUpdateNav)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.UI.UPDATE_NAV, this.handleUpdateNav)
            },

            handleUpdateNav(e) {
                if (e.pathname === this.props.link) {
                    this.update({
                        active: true
                    })
                } else {
                    this.update({
                        active: false
                    });
                }
            }
        }

    </script>
</item-nav>
